import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectPdfFilePath = (state) => get(state, 'pdfFilePath');
export const selectDocumentType = (state) => get(state, 'documentType');
export const selectFulfillmentPlanIds = (state) => get(state, 'fulfillmentPlanIds', emptyArray);
export const selectFulfillmentIds = (state) => get(state, 'fulfillmentIds', emptyArray);
export const selectEndOfDayScanFormIds = (state) => get(state, 'endOfDayScanFormIds', emptyArray);
export const selectPrintDestination = (state) => get(state, 'printDestination');
export const selectPrintDocumentFormat = (state) => get(state, 'printDocumentFormat');
export const selectOutputType = (state) => get(state, 'outputType');
export const selectOptionalManuallySetDocCount = (state) => get(state, 'optionalManuallySetDocCount');
export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectRemeberPrintSettings = (state) => get(state, 'rememberPrintSettings', false);
